import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import _get from 'lodash/get';

import LangSelector2 from 'components/LangSelector2/LangSelector2';
import FlowLogo from 'assets/images/flow/flow.svg';
import ModalTermsOfService from './components/ModalTermsOfService/ModalTermsOfService';
import ModalHowItWorks from './components/ModalHowItWorks/ModalHowItWorks';
import ContactLinks from './components/ContactLinks/ContactLinks';

import styles from './style.cssmodule.css';

const PRODUCT = __PRODUCT__; // eslint-disable-line no-undef
/* eslint-disable import/no-dynamic-require */
const PageIllustration = require(`./assets/${PRODUCT}.svg`);

function AuthenticationLayout({
  title,
  subtitle,
  children,
  Message,
  RedirectionButton,
}) {
  const logoUrl = useSelector((state) => _get(state, 'cpmSlug.current.result.customization.logo', null));
  const companyName = useSelector((state) => _get(state, 'cpmSlug.current.result.customization.title', null));

  /* Footer */
  /* ------ */
  const ClientFooter = (
    <React.Fragment>
      <div className={styles.links}>
        <ContactLinks />
      </div>
      <ul className={styles.links}>
        <ModalHowItWorks />
        <ModalTermsOfService />
      </ul>
    </React.Fragment>
  );
  const ClientManager = null;

  let Footer = null;
  if (PRODUCT === 'cpm_client') Footer = ClientFooter;
  if (PRODUCT === 'cpm_manager') Footer = ClientManager;

  return (
    <div className={styles.container}>

      {/* ← Left part */}
      <div className={styles.leftPart}>
        <div className={styles.leftPartContainer}>
          <img src={FlowLogo} className={styles.logoFlow} alt="Flow" />
          <img src={PageIllustration.default} className={styles.leftIllustration} alt="" />
        </div>
      </div>

      {/* Right part → */}
      <div className={styles.rightPart}>

        <div className={styles.topRightPart}>
          {Message}
          <div className={styles.actions}>
            {RedirectionButton}
            <LangSelector2 />
          </div>
        </div>

        <div className={styles.centerPart}>
          <div className={styles.logoAndName}>
            {logoUrl && <img src={logoUrl} alt={companyName} />}
            {companyName}
          </div>
          <div className={styles.titles}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>

          {children}
          <hr />

          {Footer}
        </div>
        <div className={styles.bottomPart} />
      </div>
    </div>
  );
}

AuthenticationLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  Message: PropTypes.node,
  RedirectionButton: PropTypes.node,
};

AuthenticationLayout.defaultProps = {
  title: null,
  subtitle: null,
  Message: null,
  RedirectionButton: null,
};

export default AuthenticationLayout;



// WEBPACK FOOTER //
// ./components/templates/AuthenticationLayout/AuthenticationLayout.jsx